import pptxgen from 'pptxgenjs'
import docmaLogo from "@/assets/docma-logo-white-red.svg"
import docmaBackground from "@/assets/docma-headslide-background.png"
import * as export_helper from './exportHelper'
import {GREEN_HEX_CODE, RED_HEX_CODE} from '@/constants/constants.js'

class PPTXBuilderPerformance{
    constructor(){
        this.pptx = new pptxgen();
        this.pptx_name = 'Docma Performance Export';
        this.dashboard_pages = [];
        this.portfolio_table_elements = [];
        this.portfolio_chart_elements = [];
    }
    set_slide(){
        this.pptx.defineSlideMaster({
            title: "docma_slide",
            background: {color: "#FFFFFF"},
            objects: [
                {text: {text: "", options: {x: 0, y: 0, w: "100%", h: '15%', fill: '#000000'}}},
                {image: {x: 8.4, y: "3%", w: 1.4,h: 0.35, path: docmaLogo}},
                { text: { text: "CONFIDENTIAL", options: { x:'0%', y:'95%', w:'100%', h:'5%', align:'center', fill:'#000000', color:'#ffffff', fontSize: 12} } },
                { text: { text: new Date().toString().slice(4, 16), options: { x:'5%', y:'95%', w:'100%', h:'5%', align:'left', color:'#ffffff', fontSize: 8 } } }
            ],
            slideNumber: { x: "90%", y: "95%", color:'#ffffff' }
        })
        this.pptx.defineSlideMaster({
            title: "docma_subheader_slide",
            objects: [
                {image: {x: 0, y: 0, w:'100%' ,h:'100%', path: docmaBackground}},
                {image: {x: 8.4, y: "3%", w: 1.4,h: 0.35, path: docmaLogo}},
                {text: { text: "CONFIDENTIAL", options: { x:'0%', y:'95%', w:'100%', h:'5%', align:'center', fill:'#000000', color:'#ffffff', fontSize: 12} } }
            ]
        })
    }
    get_name(){
        return this.pptx_name;
    }
    set_name(name){
        if(name != '' && name != null) {
            this.pptx_name = name;
        }
    }

    add_header_slide(text){
        let slide = this.pptx.addSlide({masterName: "docma_subheader_slide"});
        slide.addText(text,{x: '60%',y: '15%', w: "40%", h: 3, align: 'center', fontFace: 'Poppins', fontWeight: 'Bold', fontSize: 30, color: '#ffffff'});
    }

    add_portfolio_element(element, element_type){
        if(element_type == 'table') {
            this.portfolio_table_elements.push(element)
        } else if(element_type == 'chart') {
            this.portfolio_chart_elements.push(element)
        }
    }

    add_dashboard_page(pageElement){
        this.dashboard_pages.push(pageElement)
    }

    add_portfolio_table_slide(table){
        let slide = this.pptx.addSlide({masterName: "docma_slide"});
        let table_header_name = export_helper.build_table_header_name(table.table_headers)
        let table_header_value = export_helper.build_table_header_value(table.table_headers)
        let table_body = export_helper.build_table_body(table.table_data, table_header_value);

        slide.addText(table['table_name'],
            {
                x:0, y:'0.05',w:'75%',h:'10%',
                align: 'left', fontFace: 'Poppins', fontSize: 25, color:'#ffffff'
            }
        );

        slide.addTable([table_header_name],{x:0.05, y:1.5, w:9.9, h:0.4, fontFace: 'Poppins', fontSize: 5, fill:'black', color:'#ffffff', border:{pt: "1", color: '#000000'}});
        slide.addTable(table_body, {x:0.05, y:1.9, w:9.9, autoPage:true, autoPageRepeatHeader:true, autoPageLineWeight:0.5, newSlideStartY: 1, fontFace: 'Poppins', fontSize: 5, border:{pt: "1", color: '#000000'}});
    }

    add_portfolio_sos_chart_slide(chart){
        let slide = this.pptx.addSlide({masterName: "docma_slide"});
        let chart_name = chart['chart_name'];
        let chart_image = chart['chart_image'];

        slide.addText(chart_name,
            {
                x:0 ,y:'0.05',w:'75%',h:'10%',
                align: 'left', fontFace: 'Poppins', fontSize: 25, color:'#ffffff'
            }
        );
        slide.addImage({data: chart_image, x: 0.25, y: 1.5, h: 3, w: 7});

        // sales data
        slide.addText('Sales', { x:7.5 ,y: 1 ,h:'10%', align: 'left', fontFace: 'Poppins', fontSize: 10  });
        slide.addText(export_helper.format_spend(chart['chart_data']['sales']['latest_half_year']),
            { x:7.5 ,y:1.25, h:'10%', align: 'left', fontFace: 'Poppins', fontSize: 16 }
        );
        
        slide.addText('QOQ:', { x:7.5 ,y:1.5, h:'10%', align: 'left', fontFace: 'Poppins', fontSize: 8});
        let sales_qoq_diff = chart['chart_data']['sales']['qoq_diff']
        slide.addText(export_helper.format_percentage(sales_qoq_diff),
            { x:8 ,y:1.5, h:'10%', align: 'left', fontFace: 'Poppins', fontSize: 8, color: sales_qoq_diff > 0 ? GREEN_HEX_CODE : RED_HEX_CODE }
        );
        
        slide.addText('YOY:', { x:7.5 ,y:1.7, h:'10%', align: 'left', fontFace: 'Poppins', fontSize: 8});
        let sales_yoy_diff = chart['chart_data']['sales']['yoy_diff']
        slide.addText(export_helper.format_percentage(sales_yoy_diff),
            { x:8 ,y:1.7, h:'10%', align: 'left', fontFace: 'Poppins', fontSize: 8, color: sales_yoy_diff > 0 ? GREEN_HEX_CODE : RED_HEX_CODE }
        );

        // share of search data
        slide.addText('Share of Search', { x:7.5 ,y: 2.5 ,h:'10%', align: 'left', fontFace: 'Poppins', fontSize: 10  });
        slide.addText(export_helper.format_spend(chart['chart_data']['sos']['latest_half_year']),
            { x:7.5 ,y:2.75, h:'10%', align: 'left', fontFace: 'Poppins', fontSize: 16 }
        );
        
        slide.addText('QOQ:', { x:7.5 ,y:3, h:'10%', align: 'left', fontFace: 'Poppins', fontSize: 8});
        let sos_qoq_diff = chart['chart_data']['sos']['qoq_diff']
        slide.addText(export_helper.format_percentage(sos_qoq_diff),
            { x:8 ,y:3, h:'10%', align: 'left', fontFace: 'Poppins', fontSize: 8, color: sos_qoq_diff > 0 ? GREEN_HEX_CODE : RED_HEX_CODE }
        );
        
        slide.addText('YOY:', { x:7.5 ,y:3.2, h:'10%', align: 'left', fontFace: 'Poppins', fontSize: 8});
        let sos_yoy_diff = chart['chart_data']['sos']['yoy_diff']
        slide.addText(export_helper.format_percentage(sos_yoy_diff),
            { x:8 ,y:3.2, h:'10%', align: 'left', fontFace: 'Poppins', fontSize: 8, color: sos_yoy_diff > 0 ? GREEN_HEX_CODE : RED_HEX_CODE }
        );

        // competetive share of search data
        slide.addText('Competetive SOS', { x:7.5 ,y: 3.8 ,h:'10%', align: 'left', fontFace: 'Poppins', fontSize: 10  });
        slide.addText(export_helper.format_spend(chart['chart_data']['csos']['latest_half_year']),
            { x:7.5 ,y:4.05, h:'10%', align: 'left', fontFace: 'Poppins', fontSize: 16 }
        );
        
        slide.addText('QOQ:', { x:7.5 ,y:4.3, h:'10%', align: 'left', fontFace: 'Poppins', fontSize: 8});
        let csos_qoq_diff = chart['chart_data']['csos']['qoq_diff']
        slide.addText(export_helper.format_percentage(csos_qoq_diff),
            { x:8 ,y:4.3, h:'10%', align: 'left', fontFace: 'Poppins', fontSize: 8, color: csos_qoq_diff > 0 ? GREEN_HEX_CODE : RED_HEX_CODE }
        );
        
        slide.addText('YOY:', { x:7.5 ,y:4.55, h:'10%', align: 'left', fontFace: 'Poppins', fontSize: 8});
        let csos_yoy_diff = chart['chart_data']['csos']['yoy_diff']
        slide.addText(export_helper.format_percentage(csos_yoy_diff),
            { x:8 ,y:4.55, h:'10%', align: 'left', fontFace: 'Poppins', fontSize: 8, color: csos_yoy_diff > 0 ? GREEN_HEX_CODE : RED_HEX_CODE }
        );
    }

    add_portfolio_time_series_comparison_chart_slide(chart){
        let slide = this.pptx.addSlide({masterName: "docma_slide"});
        let chart_name = chart['chart_name'];
        let chart_image = chart['chart_image'];

        slide.addText(chart_name,
            {
                x:0 ,y:'0.05',w:'75%',h:'10%',
                align: 'left', fontFace: 'Poppins', fontSize: 25, color:'#ffffff'
            }
        );
        slide.addImage({data: chart_image, x: 0.25, y: 1, h: 2.75, w: 9.5});

        const data_count = chart['chart_data'].length;
        const x_increment = 9 / data_count;
        chart['chart_data'].forEach((data, idx) => {

            slide.addText(data['y'] + ' - Q' +data['q'],
                { x:1 + (idx * x_increment), y: 3.75, h:'10%', align: 'left', fontFace: 'Poppins', fontSize: 6 }
            );

            slide.addText('Spend', { x:0.5 + (idx * x_increment), y: 4, h:'10%', align: 'left', fontFace: 'Poppins', fontSize: 6 });
            slide.addText(export_helper.format_spend(data['spend']),
                { x:0.5 + (idx * x_increment), y: 4.15, h:'10%', align: 'left', fontFace: 'Poppins', fontSize: 8 }
            );
            slide.addText(export_helper.format_percentage(data['qoq_spend']),
                { x:1.25 + (idx * x_increment), y: 4.15, h:'10%', align: 'left', fontFace: 'Poppins', fontSize: 6,
                    color: data['qoq_spend'] > 0 ? GREEN_HEX_CODE : RED_HEX_CODE 
                }
            );
            slide.addText(export_helper.format_percentage(data['yoy_spend']),
                { x:1.75 + (idx * x_increment), y: 4.15, h:'10%', align: 'left', fontFace: 'Poppins', fontSize: 6,
                    color: data['yoy_spend'] > 0 ? GREEN_HEX_CODE : RED_HEX_CODE 
                }
            );
            slide.addText('QOQ',
                { x:1.25 + (idx * x_increment), y: 3.9, h:'10%', align: 'left', fontFace: 'Poppins', fontSize: 4 }
            );
            slide.addText('YOY',
                { x:1.75 + (idx * x_increment), y: 3.9, h:'10%', align: 'left', fontFace: 'Poppins', fontSize: 4 }
            );

            slide.addText('ROS', { x:0.5 + (idx * x_increment), y: 4.35, h:'10%', align: 'left', fontFace: 'Poppins', fontSize: 6  });
            slide.addText(export_helper.format_number(data['roas']), 
                { x:0.5 + (idx * x_increment), y: 4.5, h:'10%', align: 'left', fontFace: 'Poppins', fontSize: 8 }
            );
            slide.addText(export_helper.format_percentage(data['qoq_roas']),
                { x:1.25 + (idx * x_increment), y: 4.5, h:'10%', align: 'left', fontFace: 'Poppins', fontSize: 6,
                    color: data['qoq_roas'] > 0 ? GREEN_HEX_CODE : RED_HEX_CODE
                }
            );
            slide.addText(export_helper.format_percentage(data['yoy_roas']),
                { x:1.75 + (idx * x_increment), y: 4.5, h:'10%', align: 'left', fontFace: 'Poppins', fontSize: 6,
                    color: data['yoy_roas'] > 0 ? GREEN_HEX_CODE : RED_HEX_CODE
                }
            );

            slide.addText('Attribution', { x:0.5 + (idx * x_increment), y: 4.7, h:'10%', align: 'left', fontFace: 'Poppins', fontSize: 6 });
            slide.addText(export_helper.format_spend(data['sales_attribution']),
                { x:0.5 + (idx * x_increment), y: 4.85, h:'10%', align: 'left', fontFace: 'Poppins', fontSize: 8 }
            );
            slide.addText(export_helper.format_percentage(data['qoq_sales_attribution']),
                { x:1.25 + (idx * x_increment), y: 4.85, h:'10%', align: 'left', fontFace: 'Poppins', fontSize: 6,
                    color: data['qoq_sales_attribution'] > 0 ? GREEN_HEX_CODE : RED_HEX_CODE
                }
            );
            slide.addText(export_helper.format_percentage(data['yoy_sales_attribution']),
                { x:1.75 + (idx * x_increment), y: 4.85, h:'10%', align: 'left', fontFace: 'Poppins', fontSize: 6,
                    color: data['yoy_sales_attribution'] > 0 ? GREEN_HEX_CODE : RED_HEX_CODE
                }
            );
        })
    }

    add_portfolio_chart_slide(chart){
        let slide = this.pptx.addSlide({masterName: "docma_slide"});
        let chart_name = chart['chart_name'];
        let chart_image = chart['chart_image'];

        slide.addText(chart_name,
            {
                x:0 ,y:'0.05',w:'75%',h:'10%',
                align: 'left', fontFace: 'Poppins', fontSize: 25, color:'#ffffff'
            }
        );
        slide.addImage({data: chart_image, x: 0.25, y: 1.5, h: 3, w: 7});
        slide.addText("Note:", {x:7.5, y:2, w:1.75, align: 'left', fontFace: 'Poppins', fontSize: 15});
    }

    add_dashboard_chart_slide(pageElement){
        let slide = this.pptx.addSlide({masterName: "docma_slide"});
        slide.addText(pageElement['title'],
            {
                x:0 ,y:0,w:'100%',h:'15%',
                align: 'left', fontFace: 'Poppins', fontSize: 25, color:'#ffffff'
            }
        );

        let miniChartHeight = 0.5;
        let mainChartHeight = 3 - miniChartHeight * pageElement["miniCharts"].length;

        // main chart
        slide.addImage({data: pageElement["mainChart"]['image'], x: 0.25, y: 1.25, h: mainChartHeight, w: 6.5});
        let currentY = mainChartHeight + 1.25;

        // main chart indicators
        let indicatorCount = 0
        let indicatorY = 0
        for(let idx = pageElement["indicators"].length - 1; idx >= 0; idx--){
            indicatorY = currentY - 0.3 - (indicatorCount * 0.2)
            slide.addShape(this.pptx.shapes.ARC, { x: 5.75, y: indicatorY, w: 0.1, h: 0.1, fill: { color: pageElement["indicators"][idx]["metric_color"] }, angleRange: [0, 360] });
            slide.addText(pageElement["indicators"][idx]["metric_name"],
                {
                    x: 5.85, y: indicatorY - 0.025, w: 1, h: 0.15,
                    align: 'left', fontFace: 'Poppins', fontSize: 6, color:'#000000'
                }
            );
            indicatorCount++;
        }

        // minichart
        for( let i = 0; i < pageElement["miniCharts"].length; i++){
            slide.addImage({data: pageElement["miniCharts"][i]['image'], x: 0.25, y: currentY, h: miniChartHeight, w: 6.5});
            currentY += miniChartHeight
        }

        // response curve
        slide.addImage({data: pageElement["responseCurve"]['image'], x: 7, y: 1.5, h: 1.5, w: 2.75});
        let responseDataIdx = 0
        for (let stat in pageElement["responseCurve"]["data"]){
            slide.addText(stat,
                {
                    x: 7,y: 3.15 + 0.2 * responseDataIdx, h: 0.2, w: 1.5,
                    align: 'left', fontFace: 'Poppins', fontSize: 8,  color:'#000000'
                }
            );
            slide.addText(pageElement["responseCurve"]["data"][stat], 
                {
                    x: 8,y: 3.15+ 0.2 * responseDataIdx, h: 0.2, w: 1,
                    align: 'right', fontFace: 'Poppins', fontSize: 8, color:'#000000'
                }
            );
            responseDataIdx++;
        }
    }

    build(){
        this.set_slide();
        this.add_header_slide("Docma Charts Export");

        // build portfolio pages
        this.portfolio_table_elements.forEach((table) => {
            this.add_portfolio_table_slide(table);
        })

        this.portfolio_chart_elements.forEach((chart) => {
            if(chart['chart_ref'] == 'portfolio_sos_chart') {
                this.add_portfolio_sos_chart_slide(chart);
            } else if(chart['chart_ref'] == 'portfolio_time_series_comparison_chart') {
                this.add_portfolio_time_series_comparison_chart_slide(chart)
            } else {
                this.add_portfolio_chart_slide(chart);
            }
        })

        this.add_header_slide("Dashboard Charts");

        // build dashboard pages
        this.dashboard_pages.forEach((page) => {
            this.add_dashboard_chart_slide(page);
        })
    }

    save(){
        this.pptx.writeFile(this.pptx_name);
    }
}
export default PPTXBuilderPerformance